<script>
 import {
        MDBModal,
        MDBModalHeader,
        MDBModalTitle,
        MDBModalBody,
        MDBCollapse,
        MDBBtn
    } from 'mdb-vue-ui-kit';
  import 'vue-json-viewer/style.css'
  import JsonViewer from 'vue-json-viewer/ssr';
  import { reactive, defineComponent } from 'vue';
  import MonthNav from '../components/MonthNav.vue';
  import BudgetItemGrid from '../components/BudgetItemGrid.vue';
  import CategoryGrid from '@/components/CategoryGrid.vue';
  import { checkLogin } from '../common/auth';
  import { get, post } from '../common/api';
  import { Chart, registerables } from 'chart.js';
  import { SankeyController, Flow } from 'chartjs-chart-sankey';

  Chart.register(...registerables, SankeyController, Flow);

  export default defineComponent({
    name: "MonthView",
    components: {
      BudgetItemGrid,
      CategoryGrid,
      MonthNav,
      MDBModal,
      MDBModalBody,
      MDBModalHeader,
      MDBModalTitle,
      JsonViewer,
      MDBCollapse,
      MDBBtn
    },
    props: {
      month: Number,
      year: Number
    },
    data() {

      return {
        accordion_open: reactive(""),
        expenses: reactive([]),
        savings: reactive([]),
        incomes: reactive([]),
        transfers: reactive([]),
        credit_card_payments: reactive([]),
        loading: true,
        selected_month: this.month - 1,
        selected_year: this.year,
        show_modal: false,
        categories: reactive([]),
        display_categories: reactive([]),
        selected_category: reactive({}),
        monthDataCache: new Map(),
        collapseCategories: true,
        collapseExpenses: true,
        collapseTransfers: true,
        collapseIncome: false,
        collapseSaving: false,
        collapseCcPayments: false,
        sankeyChart: null,
        sankeyUpdatePending: false,
        sankeyInitialized: false,
      };
    },
    computed: {
      sankeyData() {
        return this.prepareSankeyData();
      }
    },
    methods: {
      setSelectedTransaction(transaction) {
        this.selected_transaction = transaction;
        console.log("accordion_open: ")
        console.log(this.accordion_open)
      },
      setSelectedCategory(category) {
        this.selected_category = category;
      },
      getCacheKey(month, year) {
        return `${year}-${String(month).padStart(2, '0')}`;
      },
      getCachedData(month, year) {
        const cacheKey = this.getCacheKey(month, year);
        return this.monthDataCache.get(cacheKey);
      },
      setCachedData(month, year, data) {
        const cacheKey = this.getCacheKey(month, year);
        this.monthDataCache.set(cacheKey, data);
      },
      getPreviousMonth(month, year) {
        if (month === 1) {
          return { month: 12, year: year - 1 };
        }
        return { month: month - 1, year: year };
      },
      preloadPreviousMonths() {
        const currentMonth = this.selected_month + 1;
        const currentYear = this.selected_year;
        
        const prev1 = this.getPreviousMonth(currentMonth, currentYear);
        const prev2 = this.getPreviousMonth(prev1.month, prev1.year);
        
        const preloadPromises = [];
        
        // Only preload if not already cached
        if (!this.getCachedData(prev1.month, prev1.year)) {
          preloadPromises.push(this.preloadMonthData(prev1.month, prev1.year));
        }
        
        if (!this.getCachedData(prev2.month, prev2.year)) {
          preloadPromises.push(this.preloadMonthData(prev2.month, prev2.year));
        }
        
        if (preloadPromises.length > 0) {
          console.log(`Preloading ${preloadPromises.length} month(s) for ${currentMonth}/${currentYear}`);
          Promise.all(preloadPromises).catch(err => {
            console.error('Error preloading previous months:', err);
          });
        } else {
          console.log(`All previous months already cached for ${currentMonth}/${currentYear}`);
        }
      },
      async preloadMonthData(month, year) {
        const cachedData = this.getCachedData(month, year);
        if (cachedData) {
          return;
        }
        
        try {
          const mm = String(month).padStart(2, '0');
          const yyyy = String(year);
          const query = '?month=' + mm + '&year=' + yyyy;
          
          const result = await get('transactions' + query);
          if (result.status === 401) {
            localStorage.removeItem('token');
            this.$router.push('/login');
            throw new Error("Unauthorized");
          }
          
          const data = await result.json();
          const transactions = data.Items;
          const sortedTransactions = this.sortTransactions(transactions);
          
          const processedData = this.processTransactionData(sortedTransactions);
          this.setCachedData(month, year, processedData);
          
          console.log(`Preloaded data for ${month}/${year}`);
        } catch (err) {
          console.error(`Failed to preload data for ${month}/${year}:`, err);
        }
      },
      processTransactionData(transactions) {
        let expenses = [];
        let incomes = [];
        let savings = [];
        let credit_card_payments = [];
        let transfers = [];
        
        transactions?.forEach((transaction) => {
          if ("v3_deleted" in transaction 
            && transaction.v3_deleted 
            && localStorage.getItem('debug') !== 'true') {
            return;
          }
          
          if ("v3_type" in transaction) {
            if (transaction['v3_type'] === 'investment') {
              savings.push(transaction);
            }
            else if (transaction['v3_type'].includes('expense')) {
              expenses.push(transaction);
            }
            else if (transaction['v3_type'].includes('income')) {
              incomes.push(transaction);
            }
            else if (transaction['v3_type'].includes('cc_payment')) {
              credit_card_payments.push(transaction);
            }
            else if (transaction['v3_type'].includes('transfer')) {
              transfers.push(transaction)
            }
          }
        });
        
        return {
          expenses,
          incomes,
          savings,
          credit_card_payments,
          transfers
        };
      },
      showDetailView() {
        console.log("show modal")
        this.show_modal = true;
      },
      closeModal() {
        this.show_modal = false;
      },
      transactionEdited() {
        console.log("transaction edited")
        this.calculateCategoryTotals();
        this.removeDeleted();
      },     
      removeDeleted() {
        if (localStorage.getItem('debug') !== 'true') {
          this.expenses = this.expenses.filter((e) => e.v3_deleted !== true)
          this.incomes = this.incomes.filter((e) => e.v3_deleted !== true)
          this.transfers = this.transfers.filter((e) => e.v3_deleted !== true)
          this.savings = this.savings.filter((e) => e.v3_deleted !== true)
          this.credit_card_payments = this.credit_card_payments.filter((e) => e.v3_deleted !== true)
        }
      },
      calculateCategoryTotals() {
        console.log("calculating category totals")
        let category_totals = {};
        this.expenses.forEach((expense) => {
          if (expense.v3_category in category_totals) {
            category_totals[expense.v3_category] += Number(expense.v3_amount);
          }
          else {
            category_totals[expense.v3_category] = Number(expense.v3_amount);
          }
        });
        this.transfers.forEach((expense) => {
          if (expense.v3_category !== 'other') {
            if (expense.v3_category in category_totals) {
              category_totals[expense.v3_category] += Number(expense.v3_amount);
            }
            else {
              category_totals[expense.v3_category] = Number(expense.v3_amount);
            }
          }
        });
        let newCategories = [];
        this.categories?.forEach((category) => {
          //console.log("processing category: ", category.name)
          if (category.name in category_totals) {
            category.spent = Number(category_totals[category.name]);
          }
          else {
            category.spent = 0.0;
          }
          //console.log("spent: ", category.spent)
          newCategories.push(category);
        });
        this.categories = newCategories;
      },
      getCategories() {
        console.log("getting categories")
        this.loading = true;

        return get('categories')
          .then(result => {
            if (result.status == 401) {
              localStorage.removeItem('token');
              this.$router.push('/login');
              throw new Error("Unauthorized");
            }
            return result;
          })
          .then(result => result.json())
          .then(data => {
            this.getTransactions();
            console.log("got category data")
            this.categories = data
            if (this.categories) {
              this.display_categories = [];
              this.categories?.forEach(category => {
                this.display_categories.push({ text: category.display_name, value: category.name });
              });
              this.calculateCategoryTotals();
            }
            
          });
      },
      getTransactions() {
        console.log("getting transactions")
        this.loading = true;
        
        const currentMonth = this.selected_month + 1;
        const currentYear = this.selected_year;
        
        // Check cache first
        const cachedData = this.getCachedData(currentMonth, currentYear);
        if (cachedData) {
          console.log(`Loading data from cache for ${currentMonth}/${currentYear}`);
          this.expenses = cachedData.expenses;
          this.incomes = cachedData.incomes;
          this.savings = cachedData.savings;
          this.credit_card_payments = cachedData.credit_card_payments;
          this.transfers = cachedData.transfers;
          this.calculateCategoryTotals();
          this.loading = false;
          
          // Always preload previous months relative to current selection
          this.preloadPreviousMonths();
          return;
        }
        
        let mm = String(currentMonth).padStart(2, "0")
        let yyyy = String(currentYear)
        var query = '?month=' + (mm) + '&year=' + (yyyy);
        get('transactions' + query)
          .then(result => {
            if (result.status == 401) {
              localStorage.removeItem('token');
              this.$router.push('/login');
              throw new Error("Unauthorized");
            }
            return result;
          })
          .then(result => result.json())
          .then(result => result.Items)
          .then(data => data = this.sortTransactions(data))
          .then(remoteRowData => {
            console.log("got transaction data")
            const processedData = this.processTransactionData(remoteRowData);
            
            this.expenses = processedData.expenses;
            this.incomes = processedData.incomes;
            this.savings = processedData.savings;
            this.credit_card_payments = processedData.credit_card_payments;
            this.transfers = processedData.transfers;
            
            // Cache the data
            this.setCachedData(currentMonth, currentYear, processedData);
            
            this.calculateCategoryTotals();
            this.loading = false;
            
            // Preload previous months after current month data is loaded
            this.preloadPreviousMonths();
          })
          .catch(err => { alert(err); this.loading = false; });
          
      },
      sortTransactions (rowData) {
        if (rowData) {
          rowData.sort(function(a, b) {
            let a_date = Date.parse(a.authorized_date ? a.authorized_date : a.date);
            let b_date = Date.parse(b.authorized_date ? b.authorized_date : b.date);
            if (a_date < b_date) {
              return -1;
            }
            else if (a_date > b_date) {
              return 1
            }
            return 0;
          });
        }
        return rowData
      },
      onFileChanged(event) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          let lines = data.split(/\r\n|\n/);
          lines = lines.slice(1);
          let transactions = [];
          lines.forEach((line) => {
            const fields = line.split(',');
            if (fields.length > 1) {
              let date = new Date(fields[0].replace(/"/g, ''));
              let amount = parseFloat(fields[2].replace(/"/g, '')) * -1;
              let transaction = {
                v3_date: date.toISOString().split('T')[0],
                v3_name: fields[1].replace(/"/g, ''),
                v3_amount: amount,
                v3_type: amount > 0 ? 'expense' : 'cc_payment',
                v3_category: 'other',
                v3_account_name: 'Penfed - Power Cash Rewards',
              };
              console.log(transaction);
              transactions.push(transaction);
            }
          });
          post('transactions', transactions)
            .then(result => {
              if (result.status == 401) {
                localStorage.removeItem('token');
                this.$router.push('/login');
                throw new Error("Unauthorized");
              }
              return result;
            })
            .then(result => result.json())
            .then(() => {
              this.getTransactions();
            });
        };
        reader.readAsText(file);
      },
      prepareSankeyData() {
        const flows = [];

        // Process incomes as sources
        const incomesByCategory = {};
        this.incomes.forEach(income => {
          const cat = income.v3_category || 'Income';
          incomesByCategory[cat] = (incomesByCategory[cat] || 0) + Math.abs(income.v3_amount);
        });

        Object.entries(incomesByCategory).forEach(([category, amount]) => {
          if (amount > 0) {
            flows.push({
              from: category,
              to: 'Available',
              flow: amount
            });
          }
        });

        // Process negative transfers as sources (money in)
        const transfersIn = {};
        this.transfers
          .filter(t => t.v3_amount < 0)
          .forEach(transfer => {
            const cat = transfer.v3_category !== 'other' ? transfer.v3_category : 'Transfer In';
            transfersIn[cat] = (transfersIn[cat] || 0) + Math.abs(transfer.v3_amount);
          });

        Object.entries(transfersIn).forEach(([category, amount]) => {
          if (amount > 0) {
            flows.push({
              from: category,
              to: 'Available',
              flow: amount
            });
          }
        });

        // Process positive transfers as outputs (money out)
        const transfersOut = {};
        this.transfers
          .filter(t => t.v3_amount > 0)
          .forEach(transfer => {
            const cat = transfer.v3_category !== 'other' ? transfer.v3_category : 'Transfer Out';
            transfersOut[cat] = (transfersOut[cat] || 0) + transfer.v3_amount;
          });

        Object.entries(transfersOut).forEach(([category, amount]) => {
          if (amount > 0) {
            flows.push({
              from: 'Available',
              to: category,
              flow: amount
            });
          }
        });

        // Process investments as outputs
        const totalInvestments = this.savings.reduce((sum, s) => sum + Math.abs(s.v3_amount), 0);
        if (totalInvestments > 0) {
          flows.push({
            from: 'Available',
            to: 'Investments',
            flow: totalInvestments
          });
        }

        // Process expenses by category as outputs
        const expensesByCategory = {};
        this.expenses.forEach(expense => {
          const cat = expense.v3_category || 'other';
          expensesByCategory[cat] = (expensesByCategory[cat] || 0) + Math.abs(expense.v3_amount);
        });

        Object.entries(expensesByCategory).forEach(([category, amount]) => {
          if (amount > 0) {
            flows.push({
              from: 'Available',
              to: category,
              flow: amount
            });
          }
        });

        // Use JSON parse/stringify to break reactivity
        const plainFlows = JSON.parse(JSON.stringify(flows));

        return {
          datasets: [{
            data: plainFlows,
            colorMode: 'gradient',
            size: 'max',
          }]
        };
      },
      getNodeColor(nodeName) {
        // Define colors for different node types
        const colorMap = {
          'Income': '#10b981',
          'Available': '#3b82f6',
          'Investments': '#8b5cf6',
          'Transfer In': '#06b6d4',
          'Transfer Out': '#f59e0b',
          'groceries': '#ef4444',
          'rent': '#f97316',
          'utilities': '#84cc16',
          'car_payment': '#14b8a6',
          'gym_memberships': '#ec4899',
          'health_and_fitness': '#f43f5e',
          'daily_travel': '#a855f7',
          'subscriptions': '#6366f1',
          'entertainment': '#8b5cf6',
          'other': '#64748b'
        };

        return colorMap[nodeName] || '#94a3b8';
      },
      initSankeyChart() {
        // Prevent multiple simultaneous initializations
        if (this.sankeyUpdatePending) {
          return;
        }
        this.sankeyUpdatePending = true;

        const canvas = this.$refs.sankeyCanvas;
        if (!canvas) {
          this.sankeyUpdatePending = false;
          return;
        }

        // Destroy existing chart if it exists
        if (this.sankeyChart) {
          try {
            this.sankeyChart.destroy();
          } catch (e) {
            console.warn('Error destroying chart:', e);
          }
          this.sankeyChart = null;
        }

        try {
          const chartData = this.prepareSankeyData();

          // Only create chart if we have data
          if (!chartData.datasets[0].data || chartData.datasets[0].data.length === 0) {
            this.sankeyUpdatePending = false;
            return;
          }

          this.sankeyChart = new Chart(canvas, {
            type: 'sankey',
            data: chartData,
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false
                },
                tooltip: {
                  callbacks: {
                    label: (context) => {
                      const data = context.dataset.data[context.dataIndex];
                      return `${data.from} → ${data.to}: $${data.flow.toFixed(2)}`;
                    }
                  }
                }
              }
            }
          });
        } catch (error) {
          console.error('Error initializing Sankey chart:', error);
        } finally {
          this.sankeyUpdatePending = false;
        }
      },
      updateSankeyChart() {
        // Debounce updates to avoid rapid reinitializations
        if (this.sankeyUpdatePending) {
          return;
        }

        setTimeout(() => {
          this.initSankeyChart();
        }, 100);
      },

    },
    created() {
      checkLogin();
      this.getCategories();
      //this.getTransactions();
      window.addEventListener('keydown', (e) => {

          if (e.key == 'Escape') {
            console.log("ESC pressed");
            if (this.selected_transaction) {
              console.log("selected: ", this.selected_transaction);
              // sort the object by key
              const keyValuePairs = Object.entries(this.selected_transaction);
              keyValuePairs.sort((a, b) => a[0].localeCompare(b[0]));
              this.selected_transaction = Object.fromEntries(keyValuePairs);

              this.showDetailView();
            }
            e.stopPropagation();
          }

        });
    },
    mounted() {
      // Don't auto-initialize, wait for data to load via watchers
    },
    beforeUnmount() {
      if (this.sankeyChart) {
        this.sankeyChart.destroy();
        this.sankeyChart = null;
      }
    },
    watch: {
      expenses() {
        this.calculateCategoryTotals();
        // Initialize chart on first data load
        if (!this.sankeyInitialized && this.expenses.length > 0) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.initSankeyChart();
              this.sankeyInitialized = true;
            });
          }, 500);
        } else if (this.sankeyInitialized) {
          this.$nextTick(() => {
            this.updateSankeyChart();
          });
        }
      },
      incomes() {
        // Initialize chart on first data load
        if (!this.sankeyInitialized && this.incomes.length > 0) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.initSankeyChart();
              this.sankeyInitialized = true;
            });
          }, 500);
        } else if (this.sankeyInitialized) {
          this.$nextTick(() => {
            this.updateSankeyChart();
          });
        }
      },
      transfers() {
        if (this.sankeyInitialized) {
          this.$nextTick(() => {
            this.updateSankeyChart();
          });
        }
      },
      savings() {
        if (this.sankeyInitialized) {
          this.$nextTick(() => {
            this.updateSankeyChart();
          });
        }
      },
      month(newmonth) {
        this.selected_month = newmonth - 1;
        this.getTransactions();
        this.sankeyInitialized = false; // Reset so it reinitializes with new data
      },
      year(newyear) {
        this.selected_year = newyear;
        this.getTransactions();
        this.sankeyInitialized = false; // Reset so it reinitializes with new data
      },
    }
  });
  </script>

<template>
  <div>
    <MDBModal
      id="exampleModal"
      tabindex="-1"
      labelledby="detailViewModal"
      v-model="show_modal"
      size="lg"
    >
      <MDBModalHeader>
        <MDBModalTitle id="detailViewModalLabel">{{selected_transaction.v3_name}}</MDBModalTitle>
      </MDBModalHeader>
      <MDBModalBody>
        <JsonViewer
          :value=selected_transaction
          :expand-depth=1
          copyable
          expanded
        >
        </JsonViewer>
      </MDBModalBody>
    </MDBModal>
    <MonthNav
      :selected_month="selected_month"
      :selected_year="selected_year"
    />

    <!-- <div class="sankey-container">
      <h3 class="sankey-title">Monthly Cash Flow</h3>
      <div class="sankey-wrapper">
        <canvas ref="sankeyCanvas"></canvas>
      </div>
    </div> -->

    <div>
      <MDBBtn @click="collapseCategories = !collapseCategories" color="link" class="collapse-toggle">
        <i :class="collapseCategories ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
        categories
      </MDBBtn>
      <MDBCollapse v-model="collapseCategories">
        <CategoryGrid
          :data="categories"
          :loading="loading"
          @category-selected="setSelectedCategory"
        />
      </MDBCollapse>
    </div>

    <div>
      <MDBBtn @click="collapseExpenses = !collapseExpenses" color="link" class="collapse-toggle">
        <i :class="collapseExpenses ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
        spending
      </MDBBtn>
      <MDBCollapse v-model="collapseExpenses">
        <BudgetItemGrid
          heading="spending"
          type="expense"
          :data="expenses"
          :loading="loading"
          :expense_categories="display_categories"
          :selected_category="selected_category"
          :year="selected_year"
          :month="selected_month"
          @transaction-edited="transactionEdited"
          @transaction-deleted="transactionEdited"
          @transaction-added="transactionEdited"
          @transaction-selected="setSelectedTransaction"
        />
      </MDBCollapse>
    </div>

    <div>
      <MDBBtn @click="collapseTransfers = !collapseTransfers" color="link" class="collapse-toggle">
        <i :class="collapseTransfers ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
        transfers
      </MDBBtn>
      <MDBCollapse v-model="collapseTransfers">
        <BudgetItemGrid
          heading="transfers"
          type="transfers"
          :data="transfers"
          :loading="loading"
          :expense_categories="display_categories"
          :selected_category="selected_category"
          :year="selected_year"
          :month="selected_month"
          @transaction-deleted="transactionEdited"
          @transaction-edited="transactionEdited"
          @transaction-added="transactionEdited"
          @transaction-selected="setSelectedTransaction"
        />
      </MDBCollapse>
    </div>

    <div>
      <MDBBtn @click="collapseIncome = !collapseIncome" color="link" class="collapse-toggle">
        <i :class="collapseIncome ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
        income
      </MDBBtn>
      <MDBCollapse v-model="collapseIncome">
        <BudgetItemGrid
          heading="income"
          type="income"
          :data="incomes"
          :loading="loading"
          :selected_category="selected_category"
          :year="selected_year"
          :month="selected_month"
          @transaction-deleted="transactionEdited"
          @transaction-edited="transactionEdited"
          @transaction-added="transactionEdited"
          @transaction-selected="setSelectedTransaction"
        />
      </MDBCollapse>
    </div>

    <div>
      <MDBBtn @click="collapseSaving = !collapseSaving" color="link" class="collapse-toggle">
        <i :class="collapseSaving ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
        saving
      </MDBBtn>
      <MDBCollapse v-model="collapseSaving">
        <BudgetItemGrid
          heading="saving"
          type="investment"
          :data="savings"
          :loading="loading"
          :selected_category="selected_category"
          :year="selected_year"
          :month="selected_month"
          @transaction-deleted="transactionEdited"
          @transaction-edited="transactionEdited"
          @transaction-added="transactionEdited"
          @transaction-selected="setSelectedTransaction"
        />
      </MDBCollapse>
    </div>

    <div>
      <MDBBtn @click="collapseCcPayments = !collapseCcPayments" color="link" class="collapse-toggle">
        <i :class="collapseCcPayments ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
        credit card payments
      </MDBBtn>
      <MDBCollapse v-model="collapseCcPayments">
        <BudgetItemGrid
          heading="credit card payments"
          type="cc_payment"
          :data="credit_card_payments"
          :loading="loading"
          :selected_category="selected_category"
          :year="selected_year"
          :month="selected_month"
          @transaction-deleted="transactionEdited"
          @transaction-edited="transactionEdited"
          @transaction-added="transactionEdited"
          @transaction-selected="setSelectedTransaction"
        />
      </MDBCollapse>
    </div>
    <div>
      <input
        type="file"
        @change="this.onFileChanged($event)"
        accept="text/csv"
        capture
      />
    </div>
  </div>
</template>

<style scoped>
.sankey-container {
  margin: 20px 40px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.sankey-title {
  margin: 0 0 15px 0;
  font-size: 1.3rem;
  font-weight: 500;
  color: #333;
}

.sankey-wrapper {
  height: 400px;
  width: 100%;
}

.collapse-toggle {
  margin-left: 40px;
  margin-top: 20px;
  text-transform: capitalize;
  font-size: 1.2rem;
  font-weight: 500;
  padding: 8px 12px;
  text-align: left;
}

.collapse-toggle i {
  margin-right: 8px;
  transition: transform 0.3s ease;
}
</style>

<style>
/* Override MDBCollapse fixed height behavior */
.collapse.show {
  height: auto !important;
}

.collapse {
  overflow: visible !important;
}
</style>
